module.exports = __webpack_public_path__ + "static/img/fenzuhanhua2.8090545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/fenzuhanhua2.png
// module id = W3E1
// module chunks = 24